import api from '@/apis'
import Vuetify from '@/plugins/vuetify'
import downloader from 'js-file-download'

export default {
  state: {
    loading: false,
    search: '',
    dates: [],
    items_per_page: 10,
    page: 1,
    total_items: 0,
    headers: [
      { title: Vuetify.locale.t('$vuetify.__AdminSetting.logs.user_id'), key: 'user_id', width: 180 },
      { title: Vuetify.locale.t('$vuetify.__AdminSetting.user'), key: 'username', width: 180 },
      { title: Vuetify.locale.t('$vuetify.__AdminSetting.logs.action'), key: 'action' },
      { title: Vuetify.locale.t('$vuetify.__AdminSetting.logs.log_datetime'), key: 'datetime', width: 180 }
    ],
    items: []
  },
  mutations: {
    SET_LOGS_LOADING(state, payload) {
      state.loading = payload
    },
    SET_LOGS_DATES(state, payload) {
      state.dates = payload
    },
    SET_LOGS_SEARCH(state, payload) {
      state.search = payload
    },
    SET_LOGS_ITEMS_PER_PAGE(state, payload) {
      state.items_per_page = payload
    },
    SET_LOGS_PAGE(state, payload) {
      state.page = payload
    },
    SET_LOGS_TOTAL_ITEMS(state, payload) {
      state.total_items = payload
    },
    SET_LOGS_ITEMS(state, payload) {
      state.items = payload
    }
  },
  actions: {
    async fetchLogRecords({ state, commit }) {
      try {
        commit('SET_LOGS_LOADING', true)
        commit('SET_LOGS_ITEMS', [])
        commit('SET_LOGS_TOTAL_ITEMS', 0)

        const start_datetime = state.dates[0] ? new Date(state.dates[0] - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) : ''
        const end_datetime = state.dates[state.dates.length - 1] ? state.dates[state.dates.length - 1].toISOString().substr(0, 10) : ''

        const page = state.page
        const itemsPerPage = state.items_per_page
        const response = await api.getLogRecords({ search: state.search, limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage, start_datetime, end_datetime })
        if (response.data.success) {
          commit('SET_LOGS_ITEMS', response.data.data)
          commit('SET_LOGS_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_LOGS_LOADING', false)
      }
    },
    async exportLogRecords({ state, commit }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.exporting_log'), loading: true })
        const start_datetime = state.dates[0] ? new Date(state.dates[0] - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) : ''
        const end_datetime = state.dates[state.dates.length - 1] ? state.dates[state.dates.length - 1].toISOString().substr(0, 10) : ''

        const response = await api.downloadLogs({ start_datetime, end_datetime })
        const filename = response.headers['content-disposition'].split('filename="')[1].split('"')[0]
        downloader(response.data, filename)

        commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
